"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { loader, wrapper } from './styles.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["color", "size"];
var Loader = function Loader(_ref) {
  var color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 64 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isIE = _React$useState2[0],
    setIsIE = _React$useState2[1];
  React.useEffect(function () {
    var userAgent = window.navigator.userAgent;
    var isIE = /Trident\/|MSIE/.test(userAgent);
    setIsIE(isIE);
  }, []);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(loader, _extends({
    "data-testid": "elemental-Loader"
  }, props, {
    $size: size,
    $isIE: isIE,
    "aria-label": "Loading",
    role: "progressbar",
    "aria-busy": "true"
  }), /*#__PURE__*/React.createElement(wrapper, null, /*#__PURE__*/React.createElement("svg", {
    width: 48,
    height: 48,
    viewBox: [0, 0, 48, 48].join(' ')
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21,
    fill: "none",
    stroke: color ? color : theme.colors.primary
  }))));
};

export { Loader };
